import { Context } from "effect";
export class EndpointVisibility extends Context.Tag("@superwall/api/dash-api/EndpointVisibility")() {
}
